export enum TCommonFieldSize {
  Small = 2,
  Medium = 4,
  Half = 6,
  Large = 8,
  Full = 12,
}
